import { explorePageTabsIds } from '@/constants/explore'
import { goalsTabIds } from '@/constants/goals'
import { ROUTE_NAMES } from '@/constants/routes'

export const getGoalPageRouteConfig = ({ orgId, goalId, query }) => {
  const location = {
    name: ROUTE_NAMES.GOAL,
    params: {
      orgId,
      goalId
    },
    query
  }
  return location
}

export const getKrPageRouteConfig = ({ orgId, krId, query }) => {
  const location = {
    name: ROUTE_NAMES.KR,
    params: { krId, orgId },
    query
  }
  return location
}

export const getInitiativePageRouteConfig = ({ orgId, initiativeId, query }) => ({
  name: ROUTE_NAMES.INITIATIVE,
  params: {
    orgId,
    initiativeId
  },
  query
})

export const getEditGoalPageRouteConfig = ({ orgId, goalId, query }) => {
  const location = {
    name: ROUTE_NAMES.EDIT_GOAL,
    params: { orgId, goalId },
    query
  }
  return location
}

export const getTeamPageRouteConfig = ({ orgId, teamId, entity, query }) => ({
  name: ROUTE_NAMES.TEAM,
  params: { orgId, teamId, entity },
  query
})

export const getProjectPageRouteConfig = ({ orgId, projectId, query }) => ({
  name: ROUTE_NAMES.PROJECT,
  params: { orgId, projectId },
  query
})

export const getNorthUniPageLocation = ({ orgId, entity, query }) => ({
  name: ROUTE_NAMES.NORTH_UNI,
  params: { orgId, entity },
  query
})

export const getExploreAllPageLocation = ({ orgId, subOrgId, entity, query }) => ({
  name: ROUTE_NAMES.EXPLORE_ALL,
  params: { orgId, subOrgId, entity },
  query
})

export const getTeamPageRouteConfigFromTeamInfo = (team, { entity, query } = {}) => {
  return getTeamPageRouteConfig({
    orgId: team.organizationId,
    teamId: team.id,
    entity: entity || goalsTabIds.goals,
    query
  })
}

export const getAdminPageRouteConfig = ({ orgId, subOrgId, query }) => ({
  name: ROUTE_NAMES.ADMIN_PANEL,
  params: {
    orgId,
    subOrgId
  },
  query
})

export const getNotificationsPageRouteConfig = ({ orgId, query }) => ({
  name: ROUTE_NAMES.NOTIFICATIONS,
  params: {
    orgId
  },
  query
})

export const getYourWorkPageRouteConfig = ({ orgId, subOrgId }) => ({
  name: ROUTE_NAMES.YOUR_WORK,
  params: {
    orgId,
    subOrgId
  }
})

export const getInboxPageRouteConfig = orgId => ({
  name: ROUTE_NAMES.INBOX,
  params: {
    orgId
  }
})

export const getUserPageRouteConfig = ({ orgId, subOrgId, userId }) => ({
  name: ROUTE_NAMES.USER,
  params: {
    orgId,
    subOrgId,
    userId
  }
})

export const getAllActivityPageRouteConfig = ({ orgId, subOrgId, query }) =>
  getExploreAllPageLocation({
    orgId,
    subOrgId,
    query,
    entity: explorePageTabsIds.activity
  })

export const getIdeaListPageRouteConfig = ({ orgId, listId, subOrgId }) => ({
  name: ROUTE_NAMES.IDEA_LIST,
  params: {
    orgId,
    listId,
    subOrgId
  }
})
export const getIdeaRowPageRouteConfig = ({ orgId, ideaId, query }) => ({
  name: ROUTE_NAMES.IDEA,
  params: {
    orgId,
    ideaId
  },
  query
})

export const getNewGoalPageRouteConfig = ({ orgId, query }) => ({
  name: ROUTE_NAMES.NEW_GOAL,
  params: {
    orgId
  },
  query
})

export const getArchivePageRouteConfig = ({ orgId, subOrgId }) => ({
  name: ROUTE_NAMES.ARCHIVE,
  params: {
    orgId,
    subOrgId
  }
})

export const getListCreationRouteConfig = ({ orgId, subOrgId, entity }) => ({
  name: ROUTE_NAMES.LISTS,
  params: {
    orgId,
    subOrgId,
    entity
  }
})

export const getCreateOrgRouteConfig = () => ({
  name: ROUTE_NAMES.CREATE_ORG
})
export const getOrgSelectRouteConfig = () => ({
  name: ROUTE_NAMES.ORG_SELECT
})
